module.exports = __webpack_public_path__ + "images/inGameItems-7596277eeadd30d3f1fe250aeb059454.svg";